import React, { useEffect, useState } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { renderRichText } from "gatsby-source-contentful/rich-text";

export default function Banner() {
	const bannerQuery = useStaticQuery(graphql`
		query {
			contentfulLabel(key: { eq: "floating-banner" }) {
				key
				value {
					raw
				}
				isEnabled
			}
		}
	`);

	let banner = bannerQuery.contentfulLabel;

	const [show, setShow] = useState(false);
	const [bannerHidden, setBannerHidden] = useState(false);

	useEffect(() => {
		setShow(banner.isEnabled);
		sessionStorage.getItem("bannerHidden") && setBannerHidden(true);
	}, [banner.isEnabled]);

	function hideBanner() {
		setShow(false);
		setBannerHidden(true);
		sessionStorage.setItem("bannerHidden", true);
	}

	return (
		<div className={`banner ${show && !bannerHidden ? "show" : "hidden"}`}>
			<div className='banner__inner'>
				<button
					onClick={() => {
						hideBanner();
					}}
					className='close'
				>
					<i className='fa fa-times' />
				</button>
				{banner.value && renderRichText(banner.value)}
			</div>
		</div>
	);
}
